import { call, all, put, takeLatest } from 'redux-saga/effects';

import { NotificationInterface } from '@e3labs/isa-data-dictionary';
import * as notificationsActions from './notifications-actions';
import { GET_ALL_REQUEST } from './notifications-constants';
import { ISA_ERROR } from '~/constants';
import { AxiosResponse } from 'axios';
import api from '~/services/api';

export function* getAll() {
  try {
    yield put(notificationsActions.setLoadingData(true));

    const { data }: AxiosResponse<NotificationInterface<any>[]> = yield call(api.get, '/notification/self');

    if (data) {
      yield put(notificationsActions.getAllSuccess(data));
    }

    yield put(notificationsActions.setLoadingData(false));
  } catch (error) {
    yield put(notificationsActions.setLoadingData(false));
    yield put({ type: ISA_ERROR, error });
  }
}

export default all([takeLatest(GET_ALL_REQUEST, getAll)]);
